import api from "./axios";
import type { Membership } from "@/types";

export const getMemberships = () =>
  api.get<Membership[]>("/memberships").then((r) => r.data);
export const getMembership = (id: string) =>
  api.get<Membership>(`/memberships/${id}`).then((r) => r.data);
export const createMembership = (data: Partial<Membership>) =>
  api.post<Membership>("/memberships", data).then((r) => r.data);
export const updateMembership = (id: string, data: Partial<Membership>) =>
  api.patch<Membership>(`/memberships/${id}`, data).then((r) => r.data);
export const deleteMembership = (id: string) =>
  api.delete(`/memberships/${id}`);
